<img
  *transloco="let t"
  [ngClass]="{'m-[8px] h-[10px] w-[10px]': size === 'xs', 'm-[9px] h-[18px] w-[18px]': size === 'md'}"
  ngSrc="assets/images/buildigo-icon-transparent-neg.svg"
  [alt]="t('shared.avatarAltText')"
  height="30"
  width="31"
/>
